import { render, staticRenderFns } from "./FieldInfoPopover.vue?vue&type=template&id=2c874fcc&"
import script from "./FieldInfoPopover.vue?vue&type=script&lang=ts&"
export * from "./FieldInfoPopover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports